// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"App_wrapper__3ox-V"};